import { z } from 'zod'

import { GetChatMessageSchema } from './chat.ts'
import { GetPlaceSchema } from './place.ts'
import { GetUserSchema } from './user.ts'

export const GetVerificationSchema = z.object({
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  user: GetUserSchema,
})

export const GetInquiryLoadSchema = z.object({
  frequency: z.unknown().nullish(),
  id: z.number(),
  inquiry_load_id: z.number().nullish(),
  load_id: z.number(),
  load_size: z.unknown().nullish(),
})

export const GetInquiryLoadWithChatSchema = z.object({
  chat_id: z.number(),
  company_name: z.string(),
  count_unread_messages: z.coerce.number().nullish(),
  destination: GetPlaceSchema,
  from_user: GetUserSchema,
  last_message: GetChatMessageSchema,
  last_message_created_at: z.coerce.date().nullish(),
  load_id: z.number(),
  load_status: z.object({
    alias: z.string(),
    title: z.string(),
  }),
  origin: GetPlaceSchema,
  quote_id: z.number(),
  quote_status: z.object({
    alias: z.string(),
    title: z.string(),
  }),
  quote_status_id: z.number(),
  role_user: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    }),
  ),
  // last_message,
})

export type GetInquiryLoadWithChat = z.infer<typeof GetInquiryLoadWithChatSchema>

export const GetInquiryLoadLogSchema = z.object({
  created_at: z.coerce.date(),
  type: z.string(),
})
